[
    {
        "person_type": {
            "name": "Cliente"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [
            {
                "RFC": "CLE810525EA1",
                "YEAR": "2008",
                "LISTA": "FUNDSANC",
                "MOTIVO": "Por cumplir con los requisitos previstos en el artículo 74 del Código Fiscal de la Federación y las reglas de la Resolución Miscelánea Fiscal",
                "IMPORTE": "4938830",
                "result_": "WITHOUT_REVIEW",
                "ID_PERSONA": "FUNDSANC00001991",
                "COINCIDENCIA": 100,
                "TIPO_PERSONA": "Persona moral",
                "CONTRIBUYENTE": "CASA LEY SA DE CV",
                "CATEGORIA_RIESGO": "Adverse Information",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "RFC": "CLE810525EA1",
                "YEAR": "2012",
                "LISTA": "FUNDSANC",
                "MOTIVO": "Por cumplir con los requisitos previstos en el artículo 74 del Código Fiscal de la Federación y las reglas de la Resolución Miscelánea Fiscal",
                "IMPORTE": "1032405",
                "result_": "WITHOUT_REVIEW",
                "ID_PERSONA": "FUNDSANC00001992",
                "COINCIDENCIA": 100,
                "TIPO_PERSONA": "Persona moral",
                "CONTRIBUYENTE": "CASA LEY SA DE CV",
                "CATEGORIA_RIESGO": "Adverse Information",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "RFC": "CLE810525EA1",
                "YEAR": "2013",
                "LISTA": "FUNDSANC",
                "MOTIVO": "Por cumplir con los requisitos previstos en el artículo 3ro transitorio de la Ley de Ingresos de la Federación para el ejercicio Fiscal de 2013",
                "IMPORTE": "178350",
                "result_": "WITHOUT_REVIEW",
                "ID_PERSONA": "FUNDSANC00001993",
                "COINCIDENCIA": 100,
                "TIPO_PERSONA": "Persona moral",
                "CONTRIBUYENTE": "CASA LEY SA DE CV",
                "CATEGORIA_RIESGO": "Adverse Information",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "RFC": "CLE810525EA1",
                "LISTA": "SAT69",
                "ESTATUS": "Condonados",
                "IDDISPO": 0,
                "result_": "REVIEW",
                "RAZONSOC": "Casa Ley Sa De Cv",
                "ID_PERSONA": "SAT6900098372",
                "NOMBRECOMP": "Casa Ley Sa De Cv",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Regulatory Enforcement",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "RFC": "CLE810525EA1",
                "LISTA": "SAT69",
                "ESTATUS": "Condonados",
                "IDDISPO": 0,
                "result_": "REVIEW",
                "RAZONSOC": "Casa Ley Sa De Cv",
                "ID_PERSONA": "SAT6900098373",
                "NOMBRECOMP": "Casa Ley Sa De Cv",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Regulatory Enforcement",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "RFC": "CLE810525EA1",
                "LISTA": "SAT69",
                "ESTATUS": "Condonados",
                "IDDISPO": 0,
                "result_": "REVIEW",
                "RAZONSOC": "Casa Ley Sa De Cv",
                "ID_PERSONA": "SAT6900098374",
                "NOMBRECOMP": "Casa Ley Sa De Cv",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Regulatory Enforcement",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "CLE810525EA1",
                        "entityType": "person"
                    }
                }
            },
            {
                "URL": "https://burocomercial.profeco.gob.mx/#",
                "LISTA": "DNSERPRO",
                "QUEJAS": "6",
                "result_": "WITHOUT_REVIEW",
                "ID_PERSONA": "DNSERPRO00006089",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Adverse Information",
                "NOMBRE COMERCIAL": "CASA LEY",
                "NOMBRE O RAZÓN SOCIAL": "CASA LEY, SA DE CV",
                "_type": "NAME",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "name": "CASA LEY",
                        "entityType": "company"
                    }
                }
            }
        ],
        "id": "f69728f0-13fe-4f8d-800c-7f038a60f8e7",
        "name": "CASA LEY",
        "rfc": "CLE810525EA1"
    },
    {
        "person_type": {
            "name": "Cliente"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [
            {
                "RFC": "WDM990126350",
                "LISTA": "SAT69",
                "ESTATUS": "ARTÍCULO 74",
                "IDDISPO": 0,
                "result_": "REVIEW",
                "RAZONSOC": "Waldos Dolar Mart De Mexico S De Rl De Cv",
                "ID_PERSONA": "SAT6900666362",
                "NOMBRECOMP": "Waldos Dolar Mart De Mexico S De Rl De Cv",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Regulatory Enforcement",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "WDM990126350",
                        "entityType": "person"
                    }
                }
            }
        ],
        "id": "26a6b412-f3d9-4e47-b126-08b8c685ddee",
        "name": "WALDO'S DOLAR MART DE MEXICO",
        "rfc": "WDM990126350"
    },
    {
        "person_type": {
            "name": "Proveedor"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [
            {
                "RFC": "BOP170629CI8",
                "LISTA": "SAT69",
                "ESTATUS": "ARTÍCULO 74",
                "IDDISPO": 0,
                "result_": "REVIEW",
                "RAZONSOC": "Bopetno Sa De Cv",
                "ID_PERSONA": "SAT6900080401",
                "NOMBRECOMP": "Bopetno Sa De Cv",
                "COINCIDENCIA": 100,
                "CATEGORIA_RIESGO": "Regulatory Enforcement",
                "_type": "RFC",
                "_conditions": {
                    "tennant": "FINBE",
                    "conditions": {
                        "rfc": "BOP170629CI8",
                        "entityType": "person"
                    }
                }
            }
        ],
        "id": "3a9355d6-d862-4e4a-8b1d-9b1f0086a8d3",
        "name": "BOPETNO",
        "rfc": "BOP170629CI8"
    },
    {
        "person_type": {
            "name": "Accionista, Propietario Real, Accionista mayoritario, Representante Legal, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "bff74e85-7c4d-4b33-b177-a619e9ddb97c",
        "name": "jesus humberto castro aispuro",
        "rfc": "CAAJ980604CL7",
        "curp": "CAAJ980604HSLSSS04"
    },
    {
        "person_type": {
            "name": "Accionista, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "6b907864-897a-4013-923f-26a4d08263ee",
        "name": "JESSICA CASTRO AISPURO",
        "rfc": "CAAJ940813KE5",
        "curp": null
    },
    {
        "person_type": {
            "name": "Otro, Cónyuge Aval, Cónyuge Aval, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "580661aa-1075-4ca2-9241-298f2ef8d1b7",
        "name": "VANYA AYSHA MEDINA DOMINGUEZ",
        "rfc": "NA",
        "curp": "MEDV970627MSLDMN05"
    },
    {
        "person_type": {
            "name": "Accionista, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "8fb0f816-b779-415d-81a3-df9a7ca6c8f2",
        "name": "JESUS HUMBERTO CASTRO CAMACHO",
        "rfc": "CACJ710727CA9",
        "curp": null
    },
    {
        "person_type": {
            "name": "Accionista, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "b24bda42-dc2a-4fff-9d92-0a3c801b663e",
        "name": "JESSICA AISPURO CASTAÑOS",
        "rfc": "AICJ710114EJ1",
        "curp": null
    },
    {
        "person_type": {
            "name": "Proveedor"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "2566c9cd-cdc1-444b-89a5-1ed0d04d19fb",
        "name": "FABPSA DEL PACIFICO",
        "rfc": "FPA110630CL6"
    },
    {
        "person_type": {
            "name": "Cliente"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "fe71d640-89e7-4fcf-a5d2-ab5e0558ac31",
        "name": "NUEVA WAL MART DE MEXICO",
        "rfc": "NWM9709244W4"
    },
    {
        "person_type": {
            "name": "Cliente"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "7295cc26-a717-4563-ae06-17c99e2acc22",
        "name": "NUEVA WAL MART DE MEXICO",
        "rfc": "NWM9709244W4"
    },
    {
        "person_type": {
            "name": "EMPRESA"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "2dc61856-47d9-46f6-a218-0d843af5fe6d",
        "name": "BREAK POINT PADEL CLUB",
        "rfc": "BPP2207121N2"
    },
    {
        "person_type": {
            "name": "Accionista, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "70660182-f59f-4c8f-a446-8c6a637374f3",
        "name": "JESUS HERNAN CASTRO GASTELUM",
        "rfc": "CAGJ790920421",
        "curp": null
    },
    {
        "person_type": {
            "name": "Accionista, "
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "e64c8710-ba00-429a-8cae-138c246e9c99",
        "name": "MARTHA CESILIA  VALENZUELA SOTELO",
        "rfc": "VASM7006066L7",
        "curp": null
    },
    {
        "person_type": {
            "name": "Proveedor"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "8af99bcc-918e-44e6-80ac-8eb7b8cdb618",
        "name": "FABPSA DEL PACIFICO",
        "rfc": "FPA110630CL6"
    },
    {
        "person_type": {
            "name": "Proveedor"
        },
        "provider": "QUIEN_ES_QUIEN",
        "results": [],
        "id": "780641bc-4e82-496b-87e5-609acc023656",
        "name": "INTEGRADORA COMERCIAL DE IMPRESOS",
        "rfc": "ICI100422TX3"
    },
    {
        "person_type": {
            "name": "EMPRESA"
        },
        "provider": "METAMAP",
        "results": {
            "details": {
                "ref": "1766780474-z39srgCm",
                "hits": [],
                "labels": [],
                "clientRef": "66abb5a6f06e23001e880427",
                "createdAt": "2025-12-26 20:21:14",
                "riskLevel": "unknown",
                "totalHits": 0,
                "updatedAt": "2025-12-26 20:21:14",
                "searchTerm": "AGROALIMENTOS FRESH HARVEST S.A. DE C.V.",
                "matchStatus": "no_match",
                "totalMatches": 0,
                "blacklistHits": [],
                "submittedTerm": "AGROALIMENTOS FRESH HARVEST S.A. DE C.V.",
                "totalBlacklistHits": 0
            },
            "metadata": {},
            "searchId": 2701939834,
            "profileUrl": "https://app.eu.complyadvantage.com/public/search/1766780474-z39srgCm/76711852303c",
            "searchedOn": "2025-12-26 20:21:14",
            "nameSearched": "AGROALIMENTOS FRESH HARVEST S.A. DE C.V.",
            "_type": "RFC",
            "_conditions": {
                "tennant": "LENDIA",
                "conditions": {
                    "rfc": "AFH200612548",
                    "entityType": "company",
                    "company_legal_name": "AGROALIMENTOS FRESH HARVEST S.A. DE C.V."
                }
            }
        },
        "id": "2dc61856-47d9-46f6-a218-0d843af5fe6d",
        "name": "BREAK POINT PADEL CLUB",
        "rfc": "BPP2207121N2"
    },
    {
        "id": "7a20762b-5ec1-4b8b-a70a-1a33590963dd",
        "name": "HECTOR ARNOLDO PAREDES CASTRO",
        "rfc": "PACH571217NN6",
        "curp": null,
        "person_type": {
            "name": "Accionista, "
        },
        "provider": null,
        "results": null,
        "conditions": null
    },
    {
        "id": "57573164-1552-46cb-9425-6d80fc2bd0e6",
        "name": "INGRID GUADALUPE ESPINOZA ESPINOZA",
        "rfc": "EIE1810907QDO",
        "curp": null,
        "person_type": {
            "name": "Accionista, "
        },
        "provider": null,
        "results": null,
        "conditions": null
    }
]
